import React, { Component } from 'react';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';

const CountUpComponent = (props) => {
    const element =
        <div className="numbers">
            {props.prefix ?
                <span className="prefix">{`${props.prefix}`}</span>
                : ""
            }
            {props.isVisible ?
                <CountUp
                    start={props.start}
                    end={props.end}
                    duration={1.7}
                    separator=","
                    decimals={props.decimals}
                    decimal="."
                    suffix={props.numberSuffix}
                />
                : <span>{props.start}</span>
            }
            {props.suffix ?
                <span className="suffix">{` ${props.suffix}`}</span>
                : ""
            }
        </div>
    return element;
}

const CountUpOnView = (props) => {
    return (<div>
        <TrackVisibility once>
            <CountUpComponent {...props} />
        </TrackVisibility>
    </div>)
}

export default CountUpOnView;



// WEBPACK FOOTER //
// ./src/Components/CountUpOnView/CountUpOnView.jsx